import { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";

const WHATSAPP_NUMBER = "628990321333";
const WHATSAPP_MESSAGE = "Hai, selamat hari yang baik! Saya punya pertanyaan akan layanan/produk dari Mobile Xpressed. Tolong dibantu, kak";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export default function WhatsAppBubble() {
  const { t } = useLang();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  // Show a peek tooltip on first mount after a short delay
  useEffect(() => {
    const tm = setTimeout(() => setVisible(true), 400);
    const peek = setTimeout(() => setTooltipOpen(true), 1600);
    const hide = setTimeout(() => setTooltipOpen(false), 6000);
    return () => { clearTimeout(tm); clearTimeout(peek); clearTimeout(hide); };
  }, []);

  return (
    <>
      <div
        className={`fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 transition-all duration-500 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
        data-testid="whatsapp-bubble-wrapper"
      >
        {/* Peek tooltip */}
        <div
          onMouseEnter={() => setTooltipOpen(true)}
          className={`absolute right-16 bottom-1.5 origin-bottom-right transition-all duration-300 ${tooltipOpen ? "opacity-100 scale-100 translate-x-0" : "opacity-0 scale-95 translate-x-2 pointer-events-none"}`}
          data-testid="whatsapp-tooltip"
        >
          <div className="bg-white rounded-2xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.25)] border border-zinc-100 px-4 py-3 pr-8 w-[240px] relative">
            <button
              onClick={(e) => { e.stopPropagation(); setTooltipOpen(false); }}
              className="absolute top-2 right-2 w-5 h-5 rounded-full text-zinc-400 hover:text-zinc-800 hover:bg-zinc-100 flex items-center justify-center text-xs"
              aria-label={t("wa.dismiss")}
            >×</button>
            <div className="text-xs font-bold uppercase tracking-[0.15em] text-emerald-600">{t("wa.tooltipLabel")}</div>
            <div className="mt-1 text-sm font-medium text-zinc-900 leading-snug">{t("wa.tooltipMsg")}</div>
            <div className="absolute -right-1.5 bottom-4 w-3 h-3 bg-white border-r border-b border-zinc-100 rotate-[-45deg]" />
          </div>
        </div>

        {/* Floating button */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          onMouseEnter={() => setTooltipOpen(true)}
          onClick={() => setTooltipOpen(false)}
          className="group relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.55)] hover:shadow-[0_14px_36px_-6px_rgba(37,211,102,0.75)] hover:scale-105 active:scale-95 transition-all duration-200"
          aria-label={t("wa.aria")}
          data-testid="whatsapp-bubble"
        >
          {/* Pulsing rings */}
          <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-wa-ping" />
          <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-50 animate-wa-ping" style={{ animationDelay: "0.9s" }} />

          {/* WhatsApp glyph */}
          <svg viewBox="0 0 32 32" className="relative w-7 h-7 fill-current animate-wa-wave" aria-hidden="true">
            <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977.822 2.9 1.298 2.5 2.822 4.6 5.363 5.96.913.487 2.13 1.033 3.144 1.09h.128c.786 0 1.902-.63 2.243-1.35.115-.24.156-.44.156-.66 0-.415-.045-.5-.386-.712-.244-.13-2.6-1.28-2.87-1.28l-.293.03zM16.554 27.174c-2.4 0-4.798-.75-6.798-2.03l-4.744 1.516 1.545-4.615a12.44 12.44 0 0 1-2.36-7.315c0-6.94 5.652-12.585 12.585-12.585 6.945 0 12.6 5.645 12.6 12.585 0 6.94-5.655 12.583-12.583 12.583v-.14zm0-27.174C7.986 0 1.006 6.98 1.006 15.54c0 2.74.72 5.443 2.087 7.83L0 32l8.85-2.9a15.51 15.51 0 0 0 7.688 2h.015C25.11 31.1 32.08 24.116 32.08 15.556 32.08 6.98 25.114 0 16.556 0h-.002z" />
          </svg>

          {/* Green dot notification */}
          <span className="absolute -top-0.5 -right-0.5 w-3 h-3 rounded-full bg-white border-2 border-[#25D366] animate-pulse" />
        </a>
      </div>
    </>
  );
}
